import {
  useEffect,
  useMemo,
  type ReactNode,
} from "react";
import { theme } from "@/theme";
import { ThemeContext } from "./theme-context";

export interface ThemeProviderProps {
  children: ReactNode;
}

/** Applies approved HQ theme tokens to the document. */
export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    document.documentElement.dataset.theme = "hq";
  }, []);

  const value = useMemo(() => theme, []);
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}
